import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/common/confirm-dialog/confirm-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { AppConfigService } from 'src/app/app-config.service';
import { CommonService } from 'src/app/common.service';
import { LoginPopupComponent } from 'src/app/login/login-popup/login-popup.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  @HostListener('window:focus', ['$event'])
  appVisibility() {
    if (!this.authService.isLoginPopupOpened) {
      if (localStorage[this.commonService.projectName]) {
        this.commonService.ProjectLSData = JSON.parse(localStorage[this.commonService.projectName]);
      }
    }
  }

  firstName: String = '';
  lastName: String = '';

  roles: any;
  userRole: any;
  currentUser: any;
  activeRole: String = '';
  initials: String = '';

  circleColor: String = '';
  colors = ['#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00', '#D47500', '#DC2A2A'];

  appConfig: any;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private configService: AppConfigService,
    private commonService: CommonService
  ) {
    this.appConfig = configService.config;
  }

  ngOnInit(): void {
    const randomIndex = Math.floor(Math.random() * Math.floor(this.colors.length));
    this.circleColor = this.colors[randomIndex];
    this.currentUser = this.commonService.ProjectLSData['currentUser'];
    this.roles = this.commonService.ProjectLSData?.userRoleList;
    this.activeRole = this.commonService.ProjectLSData?.userActiveRole;
    this.userRole = (this.activeRole) ? this.activeRole : this.roles[0].role;
    this.firstName = this.currentUser.firstName ? this.currentUser.firstName : "";
    this.lastName = this.currentUser.lastName ? this.currentUser.lastName : "";
    this.initials = ((this.firstName?.charAt(0) || '') + (this.lastName?.charAt(0) || '')).toUpperCase();
    this.commonService.changeRoleId(this.userRole);
  }

  changeToken() {
    this.commonService.ProjectLSData['accessToken'] = '';
    this.commonService.ProjectLSData['refreshToken'] = '';
    this.commonService.ProjectLSData['sessionId'] = '';
    this.commonService.setProjectLSData();
  }

  changeRole() {
    // this.authService.checkToken().subscribe((response: any) => {
    //   if (response.data) {
    //     this.commonService.changePlace('');
    //     delete this.commonService.ProjectLSData.currentRoute;
    //     this.commonService.changeRoleId(this.userRole);
    //     this.router.navigate([`/mainboard/${(this.userRole == "APPLICATION_ADMIN") ? 'users' : 'patientList'}`]);
    //   }
    // })
    this.commonService.changePlace('');
    delete this.commonService.ProjectLSData.currentRoute;
    this.commonService.changeRoleId(this.userRole);
    // this.router.navigate([`/mainboard/${(this.userRole == "APPLICATION_ADMIN") ? 'users' : 'patientList'}`]);
  }

  logout() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "30%";
    dialogConfig.panelClass = "confirmDialog";
    dialogConfig.data = {
      headerTitle: "Logout",
      confirmMsg: 'Do you really want to logout?',
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes",
      confirmActionData: {
        currentPage: 'header',
        logoutAction: this.navToLogin,
        that: this
      },
    };
    const dialogref = this.dialog.open(ConfirmDialogComponent, dialogConfig);
  }

  navToLogin(dialogRef: any, that: any) {
    dialogRef.close();
    delete that.commonService.ProjectLSData['currentRoute'];
    that.commonService.setProjectLSData();
    if (that.commonService.webViewerWindow && !that.commonService.webViewerWindow.closed) {
      that.commonService.webViewerWindow.close();
    }
    that.authService.logoutAPICall().subscribe((response: any) => {
      if (that.commonService?.ProjectLSData) {
        that.commonService.ProjectLSData = {};
      }
      that.router.navigate(['']);
    });

  }

  changePassword() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "20%";
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      headerTitle: "Login",
      confirmMsg: "Session expired. Login again to continue",
      cancelButtonText: "Cancel",
      confirmButtonText: "Save",
      changePassword: true,
      isAccessTokenExpired: false
    };
    const dialogref = this.dialog.open(LoginPopupComponent, dialogConfig);
  }

}
